import { render } from "./MultiPartSelector.vue?vue&type=template&id=6393b024&scoped=true"
import script from "./MultiPartSelector.vue?vue&type=script&lang=js"
export * from "./MultiPartSelector.vue?vue&type=script&lang=js"

import "./MultiPartSelector.vue?vue&type=style&index=0&id=6393b024&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6393b024"]])

export default __exports__